module.exports = __webpack_public_path__ + "static/media/LOGO_NARANJA.f664da29.png";